import React, { Component } from 'react'
import Box from './Box'

class StaticBox extends Component {
  render () {
    return (
      <Box staticbox collapsable={false} {...this.props}>
        {this.props.children}
      </Box>
    )
  }
}
export default StaticBox



// WEBPACK FOOTER //
// ./src/components/basic/containers/StaticBox.js